/**
 * Capitalizes the first letter of each word in a sentence.
 *
 * @param sentence - The sentence to capitalize.
 *
 * @returns The capitalized sentence.
 */
export function capitalize(sentence: string): string {
    // Split the sentence into words
    const words = sentence.split(' ')

    // Capitalize the first letter of each word
    const capitalizedWords = words.map((word) => {
        const firstChar = word.charAt(0)
        const remainingChars = word.substring(1)

        return firstChar.toUpperCase() + remainingChars
    })

    // Join the capitalized words back into a sentence
    return capitalizedWords.join(' ')
}
